import { render, staticRenderFns } from "./pubPagination.vue?vue&type=template&id=69cd5788"
import script from "./pubPagination.vue?vue&type=script&lang=js"
export * from "./pubPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports